import { m } from "@plannello/i18n/messages";
import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";
import { Button as AriaButton } from "react-aria-components";
import { TwoFactorEnrol } from "@/components/settings/TwoFactor";
import { AuthCard } from "@/components/shell/AuthCard";
import { LocaleSwitch } from "@/components/shell/LocaleSwitch";
import { loadMe } from "@/lib/queries";
import { useSignOut } from "@/lib/session";

export const Route = createFileRoute("/two-factor-setup")({
  beforeLoad: async ({ context }) => {
    const me = await loadMe(context.queryClient);
    if (!me) throw redirect({ to: "/login", search: { redirect: undefined, error: undefined } });
    // Only people the instance policy holds back land here; everyone else goes on to the app.
    if (!me.twoFactorRequired || me.twoFactorEnabled) throw redirect({ to: "/" });
  },
  component: ForcedSetup,
});

/** Admins must enrol TOTP before the app lets them in (instance setting "Require two-factor for admins"). */
function ForcedSetup() {
  const router = useRouter();
  const signOut = useSignOut();
  return (
    <AuthCard
      title={m.tfa_required_title()}
      intro={m.tfa_required_intro()}
      footer={
        <div className="flex flex-col items-center gap-3">
          <LocaleSwitch />
          <AriaButton
            onPress={() => void signOut()}
            className="rounded-control px-1 text-sm text-fg-muted underline underline-offset-2 outline-none data-hovered:text-fg data-focus-visible:outline-2 data-focus-visible:outline-solid data-focus-visible:outline-focus"
          >
            {m.auth_sign_out()}
          </AriaButton>
        </div>
      }
    >
      <TwoFactorEnrol onDone={() => void router.navigate({ to: "/" })} />
    </AuthCard>
  );
}
